import React from 'react';
import { Grid as MuiGrid } from '@mui/material';

/**
 * SolyticsGrid - A wrapper around MUI Grid component
 *
 * Provides a responsive grid layout system based on a 12-column grid.
 * Use container prop to create a grid container and item prop for grid items.
 *
 * @component
 * @example
 * // Grid container with spacing
 * <SolyticsGrid container spacing={2}>
 *   <SolyticsGrid size={{ xs: 12, md: 6 }}>
 *     <p>Column 1</p>
 *   </SolyticsGrid>
 *   <SolyticsGrid size={{ xs: 12, md: 6 }}>
 *     <p>Column 2</p>
 *   </SolyticsGrid>
 * </SolyticsGrid>
 *
 * @example
 * // Responsive grid
 * <SolyticsGrid container spacing={3}>
 *   <SolyticsGrid size={{xs: 12, sm: 6, md: 4, lg: 3}}>
 *     <p>Responsive column</p>
 *   </SolyticsGrid>
 * </SolyticsGrid>
 *
 * @example
 * // With transitions (ref forwarding)
 * <Fade>
 *   <SolyticsGrid container spacing={2}>
 *     <p>Animated grid</p>
 *   </SolyticsGrid>
 * </Fade>
 */
const SolyticsGrid = React.forwardRef((props, ref) => {
  return <MuiGrid ref={ref} {...props} />;
});

SolyticsGrid.displayName = 'SolyticsGrid';

export default SolyticsGrid;
